module.exports = __webpack_public_path__ + "img/pdd_qd@2x.51205ce0.png";